import { PaletteMode, Theme, createTheme } from '@mui/material'
import { deepmerge } from '@mui/utils'
import { amber, deepOrange, grey } from '@mui/material/colors'

// Augment the palette to include a mynt color
declare module '@mui/material/styles' {
  interface Palette {
    mynt: Palette['primary']
    sidebar: Palette['primary']
  }
  interface PaletteOptions {
    mynt?: PaletteOptions['primary']
    sidebar?: PaletteOptions['primary']
  }
}

// Update the color options to include a mynt option
interface CustomColorOption {
  mynt: true
}
declare module '@mui/material' {
  interface ButtonPropsColorOverrides extends CustomColorOption {}
  interface IconButtonPropsColorOverrides extends CustomColorOption {}
}

const baseTheme = createTheme({})

const getDesignTokens = (mode: PaletteMode) => ({
  palette: {
    mynt: {
      main: '#fb867d',
      contrastText: '#fff',
    },
    secondary: {
      main: '#fb867d',
      contrastText: '#fff',
    },

    mode,
    ...(mode === 'light'
      ? {
          // palette values for light mode
          sidebar: baseTheme.palette.augmentColor({
            color: {
              main: grey[200],
              dark: grey[300],
            },
          }),
        }
      : {
          // palette values for dark mode
          sidebar: baseTheme.palette.augmentColor({
            color: {
              main: grey[900],
              dark: grey[800],
            },
          }),
        }),
  },
})

const theme = createTheme(getDesignTokens('light'))

export default theme
